<template>
  <!--消息详情-->
  <tk-container
    :status="status"
    @refresh="getInit"
  >
    <!--消息头部-->
    <my-header slot="header"></my-header>
    <!--消息详情-->
    <div
      class="posts-detail"
      v-if="messageDetail"
    >
      <!--头像与关注-->
      <div class="p-12 font-bold">{{messageDetail.messageTitle}}</div>
      <!--内容-->
      <div class="font-15 p-x-12 text-area-pre">{{messageDetail.IntroductionEvent}}</div>
      <!--图片-->
      <div v-if="messageDetail.pictureCombination" class="p-x-12">
        <tk-flex
          column
          v-for="(s, index) in messageDetail.pictureCombination"
          @click.native="viewImages()"
          class="m-t-15"
          :key="index"
          :style="{ paddingRight: messageDetail.pictureCombination.length === 1 ? '76px' : null }"
        >
          <van-image
            lazy-load fit="cover" style="height: 100%;" width="100%" :src="s"></van-image>
        </tk-flex>
      </div>
      <!--时间-->
      <div class="caption font-bold p-12" style="color: #999;">{{messageDetail.createdAt | datetime}}</div>
    </div>
    <!--查看大图组件-->
    <view-big-image
      ref="messageDetail"
      :watch-num="watchNum"
      v-if="messageDetail && messageDetail.pictureCombination && messageDetail.pictureCombination.length"
      :commodity-image="messageDetail.pictureCombination"
    ></view-big-image>
  </tk-container>
</template>

<script>
import viewBigImage from '@/components/viewBigImage'
import { Image as VanImage } from 'vant'
export default {
  data () {
    return {
      status: false,
      watchNum: 0, // 查看大图的起始缩影
      messageDetail: null // 消息通知详情
    }
  },
  components: {
    viewBigImage,
    [VanImage.name]: VanImage
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
      componentUpdated: function (el) {
        el.focus()
      }
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.$setFlash('messageId', this.$route.query.id)
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/3/26
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getMessageDetail() // 获取帖子详情
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 获取指定帖子详情
     * @date: 2020/3/26
     */
    async getMessageDetail () {
      if (!this.$route.query.id) { return }
      this.messageDetail = await this.$tkParse.getData(`/classes/messageNotification/${this.$route.query.id}`)
      if (!this.messageDetail.userRecords) { this.messageDetail.userRecords = [] }
      if (!this.messageDetail.userRecords.includes(this.userInfo.objectId)) {
        this.messageDetail.userRecords.push(this.userInfo.objectId)
        await this.$tkParse.put(`/classes/messageNotification/${this.$route.query.id}`, { userRecords: this.messageDetail.userRecords })
      }
    },
    /**
     * 查看大图
     * @date: 2020/5/25
     */
    viewImages (s) {
      this.$refs.messageDetail.showImages()
    }
  }
}
</script>

<style scoped lang="scss">
  /*消息详情背景*/
  .posts-detail {
    background-color: #fff;
  }
  /*消息图片样式*/
  .welfare-link-image {
    border-radius: 5px;
    overflow: hidden;
    width: 100%;
    .welfare-link-image-scale {
      width: 100vw;
      height: calc(100vw - 30px);
    }
  }
</style>
